import { NonEmptyArray } from 'types/types';
import { CURRENCY_CODE } from '../../../constants';

/**
 * These are the only availability types we're going to map to.
 * There is a sold out option, but for our purposes I chose out of stock instead.
 *
 * @see https://schema.org/ItemAvailability
 */
export enum SchemaItemAvailabilityEnum {
  InStock = 'https://schema.org/InStock',
  OutOfStock = 'https://schema.org/OutOfStock',
}

/**
 * These are the only conditions that ours can map to accurately.
 *
 * @see https://schema.org/OfferItemCondition
 */
export enum SchemaOfferItemConditionEnum {
  New = 'https://schema.org/NewCondition',
  Refurbished = 'https://schema.org/RefurbishedCondition',
}

/**
 * @see https://developers.google.com/search/docs/appearance/structured-data/product#offer-properties
 * @see https://schema.org/Offer
 */
export interface SchemaOffer {
  ['@type']: 'Offer';
  price: number;
  priceCurrency?: typeof CURRENCY_CODE;
  url?: string;
  priceValidUntil?: string; // ISO-8601 date
  availability?: SchemaItemAvailabilityEnum;
  // NOTE: only applicable for physical products (we have a few options our side, but only some of them can be mapped)
  itemCondition?: SchemaOfferItemConditionEnum;
}

/**
 * Based on feedback from third-party consultants (LiquidThought),
 * we're not going to include the keywords property which we could easily fill.
 * They are concerned that google would penalize us for "keyword stuffing".
 *
 * TODO: add the description if we're ever able to get a simpler version from the API (shorter and no markup)
 *
 * @see https://developers.google.com/search/docs/appearance/structured-data/product
 * @see https://developers.google.com/search/docs/appearance/structured-data/product#product-information
 * @see https://schema.org/Product
 */
export interface SchemaProduct {
  ['@type']: 'Product';
  name: string;
  offers: NonEmptyArray<SchemaOffer>;
  image?: string;
  description?: string;
  brand?: {
    ['@type']: 'Brand';
    name: string;
  };
}

/**
 * @see https://schema.org/Organization
 */
export interface SchemaOrganization {
  ['@type']: 'Organization';
  name: string;
  url: string;
  logo: string;
  sameAs: string[];
}
